'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiTags = function TiTags(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.7 16l-10.8-10.9c-2.2-2.2-5.1-3.4-8.2-3.4s-6.1 1.2-8.3 3.4c-2.3 2.3-3.5 5.6-3.4 8.8-1.1 1.9-1.7 3.9-1.7 6.1 0 3.1 1.2 6 3.5 8.3l5 4.9 5.8 5.8c0.7 0.7 1.5 1 2.4 1s1.7-0.3 2.4-1l11.6-11.6c1.3-1.3 1.3-3.4 0-4.7l-0.1-0.2 1.8-1.8c1.3-1.3 1.3-3.4 0-4.7z m-15.7 20.7l-5.8-5.9-5.1-4.9c-3.2-3.3-3.2-8.5 0-11.8 1.6-1.6 3.8-2.4 5.9-2.4s4.3 0.8 5.9 2.4l10.8 10.9-11.7 11.7z m3.3-24.9c-2.3-2.3-5.2-3.5-8.3-3.5-2.1 0-4.2 0.6-5.9 1.7 0.4-0.9 0.9-1.8 1.7-2.6 1.6-1.6 3.7-2.4 5.9-2.4s4.2 0.8 5.9 2.4l10.7 10.9-1.8 1.8-8.2-8.3z m-8.3 5.7c1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5s-2.5-1.1-2.5-2.5c0-1.4 1.1-2.5 2.5-2.5z m0-1.7c-2.3 0-4.2 1.9-4.2 4.2 0 2.3 1.9 4.2 4.2 4.2s4.2-1.9 4.2-4.2c0-2.3-1.9-4.2-4.2-4.2z' })
        )
    );
};

exports.default = TiTags;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/tags.js
// module id = 3236
// module chunks = 0